// Ganchos de DESENVOLVIMENTO do Andon (mock do GET /api/andon/painel).
//
// Só `npm start` (NODE_ENV = 'development') carrega o mock. No build de
// produção o NODE_ENV é fixo e o `require` fica num ramo morto, que o webpack
// nem empacota: o andonMock.js, o `?andonMock=`, o `localStorage['andon-mock']`
// e o `andon-mock-falha` não existem no bundle (conferido procurando as strings
// em build/static/js). Nada da URL, do storage ou do console muda o que a TV
// mostra em produção. Quem decide o acesso é sempre o backend.
/* eslint-disable global-require */
// A condição fica escrita em cada ternário (e não numa constante): o webpack só
// descarta o `require` quando a expressão do `?:` é literalmente o NODE_ENV.
// Em produção cada função vira uma constante (false / null / erro), sem
// nenhuma referência ao mock.
export const andonMockAtivo = process.env.NODE_ENV === 'development' ? () => require('./andonMock').andonMockAtivo() : () => false;
export const nivelAndonMock = process.env.NODE_ENV === 'development' ? () => require('./andonMock').nivelAndonMock() : () => null;
export const painelAndonMock = process.env.NODE_ENV === 'development'
  ? (modo) => require('./andonMock').painelAndonMock(modo)
  : () => Promise.reject(new Error('indisponível'));
export const aplicarParametroMock = process.env.NODE_ENV === 'development' ? (search) => require('./andonMock').aplicarParametroMock(search) : () => {};
